import { useUser } from "../../../../context/UserContext";
import useWindowDimensions from "../../../../hooks/getWindowDimensions";
import CalendarIcon from "../../../../icon/CalendarIcon";
import ChartDataIcon from "../../../../icon/ChartDataIcon";
import ChartMaximumIcon from "../../../../icon/ChartMaximumIcon";
import DollarCoinIcon from "../../../../icon/DollarCoinIcon";
import UsersIcon from "../../../../icon/UsersIcon";
import ListTooltip from "../../../../ui/ListTooltip/ListTooltip";
import { formatNumber } from "../../../../utilities/functions";
import Card from "../../../Card/Card";
import classes from "./Stats.module.css";

const Stats = () => {
  const { user } = useUser();
  const { height, width } = useWindowDimensions();

  const stats = [
    {
      icon: <DollarCoinIcon />,
      amount: `$${
        user.trackingStatistics?.balance
          ? formatNumber(user.trackingStatistics?.balance)
          : 0
      }`,
      name: "Balance",
      info: "This section displays your total balance after all trades have been closed, reflecting both profits and losses",
    },
    {
      icon: <ChartDataIcon />,
      amount: `$${
        user.trackingStatistics
          ? formatNumber(user.trackingStatistics?.statistics?.profitLoss)
          : 0
      }`,
      name: "Profit/Loss",
      info: "This section displays the overall profit or loss from your closed trades. It updates automatically with each closed trade, showing your most recent results.",
    },
    {
      icon: <ChartMaximumIcon />,
      amount: `$${
        user.trackingStatistics
          ? formatNumber(user.trackingStatistics?.statistics?.drawdown)
          : 0
      }`,
      name: "Drawdown",
      info: "This section shows the current drawdown from losing trades in your account.",
    },
    {
      icon: <CalendarIcon />,
      amount: `${
        user.trackingStatistics
          ? user.trackingStatistics?.minimumTradingDays?.currentResult
          : 0
      }`,
      name: "Trading days",
      info: "This section shows the number of days where trades were executed.",
    },
  ];
  return (
    <div
      className={`${classes.statsContainer} ${
        width <= 768 ? classes.scrollable : "row"
      }`}
    >
      {stats.map((item, i) => (
        <div
          className={`${classes.cardWrapper} ${width <= 768 ? "" : "col-3"}`}
          key={i}
        >
          <Card className={classes.statsCard}>
            <div className="mb-4">{item.icon}</div>
            <h4>{item.amount}</h4>
            <ListTooltip
              className={classes.nameText}
              tooltipCard={classes.tooltipCard}
              text={item.name}
              info={item.info}
              index={i}
            />
          </Card>
        </div>
      ))}
    </div>
  );
};

export default Stats;
